document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) document.querySelector('[data-mobile-menu]')?.classList.toggle('show');
});

async function refreshCartCount(){
  try {
    const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
    const cart = await r.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  } catch(e){}
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'A adicionar…';
  try {
    const response = await fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
    if(!response.ok) throw new Error('cart');
    await refreshCartCount();
    button.textContent = '✓ Adicionado';
    setTimeout(()=>{button.textContent=original;button.disabled=false;},1200);
  } catch(e){
    button.textContent = 'Tentar novamente';
    button.disabled = false;
  }
});
async function updateMercvelCartCount() {
  try {
    const root =
      window.Shopify && Shopify.routes
        ? Shopify.routes.root
        : '/';

    const response = await fetch(root + 'cart.js', {
      credentials: 'same-origin'
    });

    const cart = await response.json();

    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = cart.item_count;

      if (cart.item_count > 0) {
        counter.style.display = 'flex';
      } else {
        counter.style.display = 'none';
      }
    });
  } catch (error) {
    console.error('Mercvel cart counter:', error);
  }
}

document.addEventListener('DOMContentLoaded', updateMercvelCartCount);

document.addEventListener('submit', function (event) {
  const form = event.target;

  if (
    form.matches('form[action*="/cart/add"]') ||
    form.matches('.product-form')
  ) {
    setTimeout(updateMercvelCartCount, 700);
  }
});

document.addEventListener('cart:updated', updateMercvelCartCount);